import { regex } from 'vee-validate/dist/rules';
import { ValidatorUtils } from './utils';
export const regexValidator = {
    ...regex,
    message(field: string) {
        return `'${ValidatorUtils.prettifyName(field)}' does not have the expected format`;
    },
};
